//Page Components
import Home from "@/components/Home.vue";
import Login from "@/pages/Login.vue";
import Dashboard from "@/components/Dashboard.vue";
import Overview from "@/components/Overview.vue";
import Survey from "@/components/Survey.vue";
import SurveyResultsPage from "@/pages/survey/SurveyResultsPage.vue";
import SignUp from "@/pages/SignUp.vue";
import AccountSetup from "@/pages/AccountSetup.vue";
import ForgotPassword from "@/components/ForgotPassword.vue";
import ResetPassword from "@/components/ResetPassword.vue";
import Project from "@/components/Project.vue";
import User from "@/components/User.vue";
import Organization from "@/components/Organization.vue";
import Meeting from "@/pages/project/Meeting.vue";
import MeetingKickoff from "@/pages/project/MeetingKickoff.vue";
import QuestionList from "@/components/QuestionList.vue";
import ProjectList from "@/components/ProjectList.vue";
import UserList from "@/components/UserList.vue";
import OrganizationList from "@/components/OrganizationList.vue";
import EditQuestion from "@/components/EditQuestion.vue";
import CloseProject from "@/components/CloseProject.vue";
import LeaveProject from "@/components/LeaveProject.vue";
import AdminLeaveProject from "@/components/AdminLeaveProject.vue";
import Migration from "@/components/Migration.vue";
import Settings from "@/components/Settings.vue";
import Accept from "@/pages/Accept.vue";
import ChooseTenant from "@/pages/ChooseTenant.vue";
import CharterNeedsApproval from "@/pages/CharterNeedsApproval.vue";
import CharterApproved from "@/pages/CharterApproved.vue";
import ProjectPages from "@/pages/ProjectPages.vue";
import ProjectOverview from "@/pages/ProjectOverview.vue";
import ProjectUsers from "@/pages/ProjectUsers.vue";
import ProjectFacilitator from "@/pages/ProjectFacilitator.vue";
import ProjectCharter from "@/pages/ProjectCharter.vue";
import ProjectEvaluation from "@/pages/ProjectEvaluation.vue";
import ProjectActionItems from "@/pages/ProjectActionItems.vue";
import ProjectEdit from "@/pages/ProjectEdit.vue";

export default [
	{
		path: "/",
		name: "Main",
		component: Home,
		meta: { title: "Home | DashTech" },
	},
	{
		path: "/home",
		name: "Home",
		component: Dashboard,
		meta: { title: "Dashboard | DashTech" },
	},
	{
		path: "/dashboard",
		name: "Dashboard",
		component: Dashboard,
		meta: { title: "Dashboard | DashTech" },
	},
	{
		path: "/overview",
		name: "Overview",
		component: Overview,
		meta: { title: "Overview | DashTech" },
	},
	{
		path: "/evaluation/respond",
		name: "Survey",
		component: Survey,
		meta: { title: "Complete Evaluation | DashTech" },
	},
	{
		path: "/evaluation/:id/results",
		name: "Survey Results",
		component: SurveyResultsPage,
		meta: { title: "Evaluation Results | DashTech" },
	},
	{
		path: "/project/:id/meeting/:meetingId",
		name: "Meeting",
		component: Meeting,
		meta: { title: "Meeting | DashTech" },
	},
	{
		path: "/meeting/:meetingId",
		name: "Meeting",
		component: Meeting,
		meta: { title: "Meeting | DashTech" },
	},
	{
		path: "/project/:id/meeting-kickoff/:meetingId",
		name: "MeetingKickoff",
		component: MeetingKickoff,
		meta: { title: "Kickoff Meeting | DashTech" },
	},
	{
		path: '/project/:id',
		component: ProjectPages,
		name: 'ProjectPages',
		children: [
			{
				path: '',
				component: ProjectOverview,
				name: 'ProjectOverview',
				meta: { title: "Project Overview | DashTech" },
			},
			{
				path: 'users',
				component: ProjectUsers,
				name: 'ProjectUsers',
				meta: { title: "Project Overview | DashTech" },
			},
			{
				path: 'facilitator',
				component: ProjectFacilitator,
				name: 'ProjectFacilitator',
				meta: { title: "Project Overview | DashTech" },
			},
			{
				path: 'charter',
				component: ProjectCharter,
				name: 'ProjectCharter',
				meta: { title: "Project Overview | DashTech" },
			},
			{
				path: 'evaluation',
				component: ProjectEvaluation,
				name: 'ProjectEvaluation',
				meta: { title: "Project Overview | DashTech" },
			},
			{
				path: 'action-items',
				component: ProjectActionItems,
				name: 'ProjectActionItems',
				meta: { title: "Project Action Items | DashTech" },
			},
			{
				path: 'edit',
				component: ProjectEdit,
				name: 'ProjectEdit',
				meta: { title: "Edit Project | DashTech" },
			},
		],
	},
	// {
	// 	path: "/project/:id/charter",
	// 	name: "ProjectCharter",
	// 	component: ProjectCharter,
	// 	meta: { title: "Project Charter | DashTech" },
	// },
	{
		path: "/charter/needs-approval",
		name: "CharterNeedsApproval",
		component: CharterNeedsApproval,
		meta: { title: "Project Charter | DashTech" },
	},
	{
		path: "/charter/approved",
		name: "CharterApproved",
		component: CharterApproved,
		meta: { title: "Project Charter | DashTech" },
	},
	{
		path: "/projects",
		name: "Project List",
		component: ProjectList,
		meta: { title: "Projects | DashTech" },
	},
	{
		path: "/project/:id/close",
		name: "Close Project",
		component: CloseProject,
		meta: { title: "Close Project | DashTech" },
	},
	// {
	// 	path: "/project/:id/project-metrics",
	// 	name: "Edit Project Metrics",
	// 	component: EditProjectMetrics,
	// 	meta: { title: "Project Metrics | DashTech" },
	// },
	// {
	// 	path: "/project/:id/evaluation",
	// 	name: "Edit Survey",
	// 	component: EditSurvey,
	// 	meta: { title: "Edit Evaluation | DashTech" },
	// },
	// {
	// 	path: "/project/:id/evaluation/new",
	// 	name: "New Survey",
	// 	component: CreateSurvey,
	// 	meta: { title: "New Evaluation | DashTech" },
	// },
	{
		path: "/project/:id/edit-old",
		name: "Edit Project",
		component: Project,
		meta: { title: "Edit Project | DashTech" },
	},
	{
		path: "/project",
		name: "ProjectPages",
		component: ProjectPages,
		meta: { title: "Project Dashboard | DashTech" },
	},
	{
		path: "/question-template/list",
		name: "Evaluation Templates",
		component: QuestionList,
		meta: { title: "Evaluation Templates | DashTech" },
	},
	{
		path: "/question-template/new",
		name: "New Question Template",
		component: EditQuestion,
		meta: { title: "New Question Template | DashTech" },
	},
	{
		path: "/question-template/:id",
		name: "Edit Question Template",
		component: EditQuestion,
		meta: { title: "Edit Question Template | DashTech" },
	},
	{
		path: "/user/list",
		name: "User List",
		component: UserList,
		meta: { title: "Users | DashTech" },
	},
	{
		path: "/user/settings",
		name: "Settings",
		component: Settings,
		meta: { title: "Settings | DashTech" },
	},
	{
		path: "/user/:id",
		name: "User",
		component: User,
		meta: { title: "User | DashTech" },
	},
	{
		path: "/organization/list",
		name: "Organization List",
		component: OrganizationList,
		meta: { title: "Organizations | DashTech" },
	},
	{
		path: "/organization/:id",
		name: "Organization",
		component: Organization,
		meta: { title: "Organization | DashTech" },
	},
	{
		path: "/login",
		name: "Login",
		component: Login,
		meta: { title: "Login | DashTech" },
	},
	{
		path: "/sign-up",
		name: "Sign Up",
		component: SignUp,
		meta: { title: "Sign Up | DashTech" },
	},
	{
		path: "/account/setup",
		name: "Account Setup",
		component: AccountSetup,
		meta: { title: "Set up Account | DashTech" },
	},
	{
		path: "/password/forgot",
		name: "Forgot Password",
		component: ForgotPassword,
		meta: { title: "Forgot Password | DashTech" },
	},
	{
		path: "/password/reset",
		name: "Reset Password",
		component: ResetPassword,
		meta: { title: "Reset Password | DashTech" },
	},
	{
		path: "/migration",
		name: "Migration",
		component: Migration,
		meta: { title: "Migration Dashboard | DashTech" },
	},
	{
		path: "/accept",
		name: "Accept",
		component: Accept,
		meta: { title: "Authenticating | DashTech" },
	},
	{
		path: "/choose-account",
		name: "Choose Tenant",
		component: ChooseTenant,
		meta: { title: "Choose Account | DashTech" },
	},
	{
		path: "/leave-project",
		name: "Leave Project",
		component: LeaveProject,
		meta: { title: "Unsubscribe | DashTech" },

	},
	{
		path: "/admin/leave-project",
		name: "Admin Leave Project",
		component: AdminLeaveProject,
		meta: { title: "Choose Unsubscribe | DashTech" },

	},

	// // Redirects
	// {
	// 	path: '/project/:id/users',
	// 	redirect: to => ({
	// 		name: 'Project Detail',
	// 		hash: '#users-tab'
	// 	})
	// }
];
